class Sanitizer {
  /**
   * Sanitizza la stringa trasformando i caratteri accentati in caratteri normali,
   * sostituendo \ oppure / con _
   * togliendo qualsiasi altro carattere oltre a questi: a-zA-Z0-9-_.() &
   *
   * @param {string} string
   * @return {string}
   */
  static fileName (string) {
    if (!string || typeof string !== 'string') {
      return '';
    }
  
    let chars_map   = {
      '\u00E0': 'a', // à
      '\u00E8': 'e', // è
      '\u00E9': 'e', // é
      '\u00EC': 'i', // ì
      '\u00F2': 'o', // ò
      '\u00F9': 'u', // ù
      '\/':     '_', // /
      '\\':     '_'  // \
    };
    let chars_array = Object.keys(chars_map).filter((char) => {
      return true;
    }).join("")
      .replace(/\\/, "\\\\")
      .replace(/\//, "\\\/");
    let reg_exp     = new RegExp('[' + chars_array + ']', 'g');
  
    // Sostituisce i caratteri accentati con quelli non accentati
    let new_string = string.replace(reg_exp, (match, offset, string) => {
      return chars_map[match];
    });
  
    //Rimuove tutti i caratteri non alfanumerici ad esclusione del trattino
    return new_string.replace(/[^a-zA-Z0-9\-_.() &]/g, '');
  }
  
  /**
   * @deprecated
   * @use {@link fileName}
   * @param {string} string
   */
  static file_name (string) {
    return this.fileName(string);
  }
  
  /**
   * Sanitizza il testo che deve essere incollato, eseguendo il trim e rimpiazzando i caratteri non validi.
   *
   * @param {string} string
   * @returns {*}
   */
  static pastedString (string) {
    if (!string || typeof string !== 'string') {
      return '';
    }
    
    let new_str   = '';
    let chars_map = {
      '\u2019': '\'', // ’
      '\u201C': '"',  // “
      '\u201D': '"'   // ”
    };
    let reg_exp   = new RegExp('[' + Object.keys(chars_map).join('') + ']', 'g');
    
    // Effettua il trim rimuovendo gli spazzi prima e dopo il testo.
    new_str = string.trim();
    
    // Rimpiazza i caratteri non ammessi con quelli ammessi.
    new_str = new_str.replace(reg_exp, (match, offset, string) => {
      return chars_map[match];
    });
    
    return new_str;
  }
  
  /**
   * @deprecated
   * @use {@link pastedString}
   * @param {string} string
   */
  static pasted_string (string) {
    return this.pastedString(string);
  }
}

export {Sanitizer};
